import { StepType } from "@redotech/redo-return-ui/flows/step";
import {
  categoryOf,
  dragTypeFromTitle,
  FlowEditorDragType,
  StepCategoryKey,
} from "./step-type-registry";

export function stepTypeToDragType(
  stepType: StepType<any, any>,
): FlowEditorDragType | undefined {
  return dragTypeFromTitle(stepType.title);
}

/**
 * Maps a FlowEditorDragType to its corresponding StepType from the available stepOptions
 */
export function dragTypeToStepType(
  dragType: FlowEditorDragType,
  stepOptions: StepType<any, any>[],
): StepType<any, any> | undefined {
  return stepOptions.find(
    (stepType) => stepTypeToDragType(stepType) === dragType,
  );
}

/**
 * Categorizes step types into the palette's sections
 */
export interface StepCategory {
  name: string;
  steps: { stepType: StepType<any, any>; dragType: FlowEditorDragType }[];
}

export const SERVICE_REQUESTS_SECTION_NAME = "Service requests";

export function categorizeSteps(
  stepOptions: StepType<any, any>[],
  actionsSectionName = "Actions",
): StepCategory[] {
  const sections: Record<StepCategoryKey, StepCategory["steps"]> = {
    steps: [],
    actions: [],
    serviceRequests: [],
  };

  for (const stepType of stepOptions) {
    const dragType = stepTypeToDragType(stepType);
    if (!dragType) {
      continue;
    }
    sections[categoryOf(dragType)].push({ stepType, dragType });
  }

  const names: Record<StepCategoryKey, string> = {
    steps: "Steps",
    actions: actionsSectionName,
    serviceRequests: SERVICE_REQUESTS_SECTION_NAME,
  };

  // Order is the palette's reading order, not the enum's.
  return (["steps", "serviceRequests", "actions"] as const)
    .filter((key) => sections[key].length > 0)
    .map((key) => ({ name: names[key], steps: sections[key] }));
}
